import { Box, Avatar, Typography } from '@mui/material';
import { Logo } from './logo';
import { keyframes } from '@emotion/react';
import REACT_APP_LOGO_SPLASH_SCREEN from './../images/kalanke-icon.png'

const bounce1 = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, 1px, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
`;

const bounce3 = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, 3px, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
`;

export const SplashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'neutral.900',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100vw',
      zIndex: 2000
    }}
  >
   <Avatar
      src={REACT_APP_LOGO_SPLASH_SCREEN}
      sx={{
        background: 'transparent',
        width: '30vw',
        height: '30vw'
      }}
      variant="rounded"
  />
  </Box>
);
